"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var DrawerTypes = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  MANAGE: 'MANAGE'
};
var _default = DrawerTypes;
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(DrawerTypes, "DrawerTypes", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/drawer-types.js");
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/drawer-types.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJEcmF3ZXJUeXBlcyIsIkNSRUFURSIsIkVESVQiLCJERUxFVEUiLCJNQU5BR0UiXSwic291cmNlcyI6WyIuLi8uLi9zcmMvY29tbW9uL2RyYXdlci10eXBlcy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBEcmF3ZXJUeXBlcyA9IHtcblx0Q1JFQVRFOiAnQ1JFQVRFJyxcblx0RURJVDogJ0VESVQnLFxuXHRERUxFVEU6ICdERUxFVEUnLFxuXHRNQU5BR0U6ICdNQU5BR0UnLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgRHJhd2VyVHlwZXM7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQSxJQUFNQSxXQUFXLEdBQUc7RUFDbkJDLE1BQU0sRUFBRSxRQUFRO0VBQ2hCQyxJQUFJLEVBQUUsTUFBTTtFQUNaQyxNQUFNLEVBQUUsUUFBUTtFQUNoQkMsTUFBTSxFQUFFO0FBQ1QsQ0FBQztBQUFDLGVBRWFKLFdBQVc7QUFBQTtBQUFBO0FBQUE7QUFBQTtFQUFBO0VBQUE7SUFBQTtFQUFBO0VBQUEsd0JBUHBCQSxXQUFXO0VBQUE7QUFBQTtBQUFBO0FBQUE7RUFBQTtFQUFBO0FBQUEifQ==